module.exports = __webpack_public_path__ + "img/clock_icon.1a840ee5.svg";